export const NOT_ENROLLED_CODE = '3';

export const INVALID_CREDENTIALS_CODE = '6';

export const LOCKED_USER_CODE = '15';

export const INVALID_CREDENTIALS_MESSAGE = 'Usuario y/o clave incorrectas';

export const NOT_ENROLLED_MESSAGE = 'Usuario no enrolado en Banco Ripley';

export const ROUTES_WITH_BASIC_AUTHENTICATION = [
  'admin/user/connect/token'
];

export const EXTERNAL_ROUTE = [
  'jsonip.com'
];

export const REFRESH_TOKEN_REQUEST_DIFFERENTIAL = (3 / 4);

export const SECONDS_TO_MILLISECONDS = 1000;

export const CREATE_TOKEN = 1;

export const REFRESH_TOKEN = 2;

export const CREATE_TOKEN_PATH = 'connect';

export const REFRESH_TOKEN_PATH = 'refresh';

export const RESCUE_SESSION_TOKEN = 'rescueSessionToken';

export const FIREBASE_TOKEN_ERROR = 'No valid token';

export const MULTIPLE_SESSIONS_CODE = '20';

export const MULTIPLE_SESSIONS_MESSAGE = 'Tu sesión está activa';

export const RESCUE_IDENTIFIER = 'rescueIdentifier';

export const RESCUE_TOKEN_EXPIRES = 'rescueTokenExpires';

export const USER_ID = 'user_id';

export const USER_INFO = 'userInfo';

export const FACE_ID_PLATFORM_ID = 'face';

export const FACE_ID_NAME = 'Face ID';

export const LOCKED_USER_BY_ADMIN_CODE = '16';

export const LOCKED_USER_BY_ADMIN_TITLE = 'Tu acceso a la Banca en línea se encuentra temporalmente bloqueado';

export const LOCKED_USER_BY_ADMIN_MESSAGE = 'Por favor, acércate a una de nuestras Agencias para orientarte con la reactivación. '
+ 'Puedes realizar tus pagos haciendo click aquí:';

// Tarjetas adicionales
export const ROUTES_WITH_HEADER_TOKEN = [
  '/productshbk/product/active/consolidate',
  '/productshbk/product/active/detail/tc',
  '/productshbk/product/active/movements'
];
